// If we don't extend Component we may get TypeError: Cannot read properties of undefined (reading 'call')
import Component from './Component';

export default class BackToTop extends Component {
  load() {
    this.initBackToTop();
    super.load();
  }

  initBackToTop() {

    // There are two different back-to-top buttons. They have different styling and slightly different JS.

    // console.log('BackToTop.');
    const btn = $('.back-to-top-link');

    $(window).on('scroll', function () {
      if ($(window).scrollTop() > 600) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function (e) {
      $('html, body').animate({ scrollTop: 0 }, '200');
    });



    // Back-to-top Element button

    const scrollupAndFocusAction = () => {
      // console.log('js-back-to-top clicked');
      // e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, '200');

      // Select the first h1 element
      const h1 = document.querySelector('h1');

      // Check if the h1 exists
      if (h1) {
        // Add a tabindex attribute to make it focusable
        h1.setAttribute('tabindex', '-1');

        // Focus the h1 element
        h1.focus();
      }
    }


    const btns2 = document.querySelectorAll('.js-back-to-top');
    // console.log('btns2: ', btns2);

    for (let index = 0; index < btns2.length; index++) {
      const el = btns2[index];
      // console.log('add listeners', el);
      // el.addEventListener('touch', scrollupAndFocusAction);
      // el.addEventListener('mousedown', scrollupAndFocusAction);
      el.addEventListener('click', scrollupAndFocusAction);
    }


  }
}
